<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline">
          <div
            class="column is-half-tablet is-one-third-desktop"
            v-for="project in projects"
            v-bind:key="project.slug"
          >
            <post-card v-bind="project"></post-card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style type="text/css"></style>

<script>
import Database from "@/services/Database";
import PostCard from "@/components/PostCard";

export default {
  name: "projects",
  components: {
    PostCard
  },
  created: function() {
    let self = this;
    async function getProjects() {
      try {
        const response = await Database.getProjects();
        self.projectList = response.data.records;
      } catch (error) {}
    }
    getProjects();

    async function getSkills() {
      try {
        const response = await Database.getSkills();
        self.skillList = response.data.records;
      } catch (error) {}
    }
    getSkills();
  },
  data: function() {
    return {
      projectList: [],
      skillList: []
    };
  },
  computed: {
    projects() {
      let self = this;
      let projectList = [];
      for (let response of self.projectList) {
        if (response.fields.Published) {
          let skills = self.skillList.filter(function(skill) {
            return response.fields.Skills.includes(skill.id);
          });

          skills = skills.map(function(skill) {
            return { id: skill.id, ...skill.fields };
          });

          let project = {
            title: response.fields.Title,
            subtitle: response.fields.Subtitle,
            thumbnail: response.fields.Thumbnail
              ? response.fields.Thumbnail[0]
              : null,
            slug: response.fields.Slug,
            body: response.fields.Body,
            skills: skills,
            website: response.fields.ProjectPage,
            repo: response.fields.Repo
          };
          projectList.push(project);
        }
      }
      return projectList.sort((a, b) => a.slug - b.slug);
    }
  }
};
</script>
